"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _globals = require("../../../globals.js");

function _default(theme, props, state) {
  var palette = theme.palette;
  var iconOpacity = theme.appearanceOpacity;

  if (state.hover) {
    iconOpacity = theme.hoverAppearanceOpacity;
  }

  if (state.focus) {
    iconOpacity = theme.focusAppearanceOpacity;
  }

  return {
    queryWrapper: {
      position: 'relative',
      width: '100%',
      paddingRight: theme.searchPaddingRight,
      paddingLeft: theme.searchPaddingLeft,
      paddingTop: theme.searchPaddingTop,
      paddingBottom: theme.searchPaddingBottom,
      minWidth: '100px',
      boxSizing: 'border-box'
    },
    query: {
      display: 'block',
      paddingLeft: "".concat(palette.gutter * 4, "px"),
      zIndex: 1
    },
    iconWrapper: {
      position: 'absolute',
      top: "calc(50% - ".concat(palette.gutter * 1.5, "px)"),
      left: theme.searchPaddingLeft,
      opacity: iconOpacity,
      transitionProperty: 'opacity',
      transitionDuration: palette.transitionDuration,
      transitionTimingFunction: palette.transitionFunction,
      display: 'flex',
      zIndex: 2
    },
    icon: {
      width: palette.gutter * 3 + 'px',
      height: palette.gutter * 3 + 'px',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain'
    }
  };
}